import { withRouter } from 'react-router-dom';
import { useScrollRestore } from './useScrollRestore';
const ScrollRestorationHandler = function ScrollRestorationHandler({ location, ignoreForRouteTypes }) {
    useScrollRestore({
        location,
        ignoreForRouteTypes
    });
    return null;
};
export default withRouter(ScrollRestorationHandler);
//# sourceMappingURL=ScrollRestorationHandler.js.map